import classNames from 'classnames';
import Arrow from '@/icons/select-chevron.svg?react';
import { formatDate } from '@/core/helpers';
import { ProformaInvoice } from '@/core/types';
import { useTranslation } from 'react-i18next';
import { ProformaInvoiceTile } from './ProformaInvoiceTile';
import { ControlledCollapse } from '../Collapse/ControlledCollapse';

interface Props {
  initialOpened?: boolean;
  date: Date;
  invoices: { [key: string]: ProformaInvoice[] };
}

export const ProformaInvoicesCollapse = ({
  initialOpened,
  date,
  invoices,
}: Props) => {
  const { t } = useTranslation();

  return (
    <ControlledCollapse
      initialOpened={initialOpened}
      triggerRenderer={(isOpened, toggleCollapse) => (
        <div
          className={`flex cursor-pointer items-start ${
            isOpened ? 'rounded-t-lg ' : 'rounded-lg'
          } border py-2 pl-4 pr-2`}
          onClick={toggleCollapse}
        >
          <div className='SellerPastPeriodsFiling__top flex-shrink-0 font-extrabold'>
            {formatDate(date, 'MMMM yyyy')}
          </div>
          <div className='flex flex-grow items-start justify-end'>
            <div className='flex'>
              {Object.values(invoices).length}
              &nbsp;
              <span>{t('files')}</span>
            </div>
            <Arrow
              className={classNames('SellerPastPeriodsFiling__arrow', {
                'SellerPastPeriodsFiling__arrow--active': isOpened,
              })}
            />
          </div>
        </div>
      )}
      contentRenderer={() => (
        <div className='divide-y rounded-b-lg border-b border-l border-r'>
          {Object.entries(invoices)
            .sort(([key1], [key2]) => key1.localeCompare(key2))
            .map(([k, v]) => {
              return <ProformaInvoiceTile invoices={v} key={k} />;
            })}
        </div>
      )}
    />
  );
};
